// src/features/rate-limit/rateLimitBanTracker.ts
// Эвристика «аккаунт во временном бане»: anti-bot система бека банит аккаунт
// целиком, поэтому 429 приходят сразу от РАЗНЫХ эндпоинтов. Одиночные/повторные
// 429 одного эндпоинта — обычный троттлинг ручки, не бан.
// TODO: заменить эвристику на явный маркер бана от бека, когда появится.

const BAN_429_WINDOW_MS = 10_000
const BAN_429_MIN_ENDPOINTS = 2

interface RateLimitHit {
  endpoint: string
  at: number
}

let hits: RateLimitHit[] = []

export const registerRateLimitHit = (endpoint: string, now: number): boolean => {
  hits = hits.filter((hit) => now - hit.at < BAN_429_WINDOW_MS)
  hits.push({ endpoint, at: now })

  const uniqueEndpoints = new Set(hits.map((hit) => hit.endpoint))
  return uniqueEndpoints.size >= BAN_429_MIN_ENDPOINTS
}

export const resetRateLimitHits = (): void => {
  hits = []
}
